import { debounce } from '../../core/helpers';

let previous_breakpoint = '';

const instaMobile = () => {
  const $insta_section = $('.instagram-section .instagram');
  $insta_section.find('.container').nextAll().remove();
  
  $insta_section.append(`<script defer src="//foursixty.com/media/scripts/fs.embed.v2.5.js" data-feed-id="${$insta_section.data('feed-id')}" data-theme="showcase_v2_5" data-page-size="4"></script><style>.fs-desktop .fs-entry-container { width: 50% !important; padding-top: 50% !important; }.fs-mobile .fs-entry-container { width: 50% !important; padding-top: 50% !important; }.fs-wrapper div.fs-text-container .fs-entry-title, div.fs-detail-title{font-family:Times New Roman, serif;font-style:italic;font-weight:normal;}div.fs-text-container .fs-entry-date, div.fs-detail-container .fs-post-info, div.fs-wrapper div.fs-has-links::after, .fs-text-product, .fs-overlink-text{font-family:"Raleway";font-style:normal;font-weight:bold;}.fs-wrapper div.fs-text-container * {color:rgb(255, 255, 255)}.fs-wrapper div.fs-text-container {background-color:rgba(0, 0, 0, 0); margin: 0px}div.fs-entry-date{display:none}div.fs-entry-title{display:none}.fs-wrapper div.fs-timeline-entry{ margin: 1px }.fs-next-page{display:none;}#fs-detail-branding{left:100000px;}</style>`);
};

const instaDesktop = () => {
  const $insta_section = $('.instagram-section .instagram');
  $insta_section.find('.container').nextAll().remove();
  
  $insta_section.append(`<script defer src="//foursixty.com/media/scripts/fs.slider.v2.5.js" data-feed-id="${$insta_section.data('feed-id')}" data-theme="${$insta_section.data('theme')}" data-cell-size="${$insta_section.data('cell-size')}"  data-connector-filter="${$insta_section.data('connector-filter')}"></script>`);
};

// We don't have control over the images provided by this app, don't load them on page load to speedup the page load
export default () => {
  const $insta_section = $('.instagram-section .instagram');

  if (!$insta_section.length) {
    return;
  }

  let insta_section_loaded = false;

  $(window).on('scroll', () => {
    const page_scrolltop = $(window).scrollTop();
    const insta_scrolltop = $insta_section.offset().top;

    if (!insta_section_loaded && page_scrolltop + $insta_section.outerHeight() + 1500 >= insta_scrolltop) {
      insta_section_loaded = true;
      window.dispatchEvent(new Event('resize'));
    }
  });

  window.addEventListener('resize', debounce(() => {
    if (insta_section_loaded && previous_breakpoint != window.theme.breakpoints.current) {
      if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
        instaMobile();
      } else {
        instaDesktop();
      }

      previous_breakpoint = window.theme.breakpoints.current;
    }
  }, 100));
};
